import {Layout} from 'antd';
import Footer from './Footer';

const BlankLayout = (props) => {
  const {children} = props;
  return (
    <Layout className="blank-layout">
      {children}
      <Footer/>
    </Layout>
  );
};

export default BlankLayout;
